import { Constant } from "../../config";
import axios from "axios";

export default {
  getPaymentLogList: async (page = 1, limit = 10, search = "") => {
    const url =
      Constant.PAYMENT_LOG_API +
      "?page=" +
      page +
      "&limit=" +
      limit +
      "&search=" +
      search;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const d = resp.data.data;

    const output = {
      totalRows: resp.data.total_rows || 0,
      dataSource: d,
    };

    return output;
  },
  getPaymentDetail: async (id) => {
    const url = Constant.PAYMENT_API + `/${id}`;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return {};
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return {};
    }

    return resp.data;
  },
  getKYCAdminReason: async () => {
    const opt = {
      url: Constant.KYC_ADMIN_REASON_API,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (e) {
      console.log(e);
      return;
    }

    if (resp.data) {
      return resp.data.data || [];
    }

    return [];
  },
};



// WEBPACK FOOTER //
// ./src/containers/PaymentLog/service.js